<ng-template #instructionsTemplate><ng-content select="[projectedInstructions]"></ng-content></ng-template>
<ng-template #tooltipTemplate><ng-content select="[projectedTooltip]"></ng-content></ng-template>

<div>
    @if (this.Mode === 'design') {
    <div class="flex-row-top-left">
        <div>
            <div class="design-mode-field-label">
                {{DisplayName}} @if (this.FormField.required) {
                <span style="color: #EF0000;">*</span>
                }
            </div>
            <ng-container *ngTemplateOutlet="instructionsTemplate"></ng-container>
            @if ((this.SelectOptions === undefined) || (this.SelectOptions === null) || (this.SelectOptions.length === 0)) {
            <mat-radio-button disabled></mat-radio-button>
            }
            @if ((this.SelectOptions !== undefined) && (this.SelectOptions !== null) && (this.SelectOptions.length > 0)) {
            @if (UseStandardRadioButtonFormat) {
            <div>
                <mat-radio-group [(ngModel)]="this.DefaultRadioButtonValue">
                    @for (strRadioButton of this.SelectOptions; track strRadioButton; let i = $index) {
                    @if ((i > 0) && (!this.IsVertical)) {
                    &nbsp;&nbsp;&nbsp;
                    }
                    @if ((i > 0) && (this.IsVertical)) {
                    <br />
                    }
                    <mat-radio-button value="{{strRadioButton}}" class="margin-left-10px" disabled>
                        {{strRadioButton}}
                    </mat-radio-button>
                    }
                </mat-radio-group>
            </div>
            }
            @if (UseHorizontalTabFormat) {
            <div>
                <mat-tab-group>
                    @for (strRadioButton of this.SelectOptions; track strRadioButton) {
                    <mat-tab label="{{strRadioButton}}"></mat-tab>
                    }
                </mat-tab-group>
            </div>
            }
            @if (UseToggleSwitchFormat) {
            <div>
                <mat-button-toggle-group>
                    @for (strRadioButton of this.SelectOptions; track strRadioButton) {
                        <mat-button-toggle value="{{strRadioButton}}">{{strRadioButton}}</mat-button-toggle>
                    }
                </mat-button-toggle-group>
            </div>
            }
            }
        </div>
        <!--
        I tried to find a way to pass a context to project tooltip in order to
        make field-specific adjustments like this, but couldn't find a way
        -->
        <div style="margin-top:-10px">
            <ng-container *ngTemplateOutlet="tooltipTemplate"></ng-container>
        </div>
    </div>
    }
    @if ((this.Mode === 'preview') || (this.Mode === 'instance')) {
    <div class="flex-row-top-left preview-instance-div">
        <div>
            @if (this.FormGroup !== null) {
            <form [formGroup]="this.FormGroup">
                @if (UseStandardRadioButtonFormat) {
                <div>
                    <div class="field-label">
                        @if (!FieldIsInGrid) {
                        {{DisplayName}}
                        }
                        @if (this.FormField.required) {
                        <span style="color: #EF0000;">*</span>
                        }
                    </div>
                    <ng-container *ngTemplateOutlet="instructionsTemplate"></ng-container>
                    <mat-radio-group formControlName="radio_buttons_form">
                        @for (strRadioButton of this.SelectOptions; track strRadioButton; let i = $index) {
                        @if ((i > 0) && (!this.IsVertical)) {
                        &nbsp;&nbsp;&nbsp;
                        }
                        @if ((i > 0) && (this.IsVertical)) {
                        <br />
                        }
                        <mat-radio-button title="{{this.DisplayName}} (Double-click to edit in a dialog)"
                                          value="{{strRadioButton}}"
                                          [disabled]="this.ReadOnly"
                                          (focus)="this.handleOnFocus($event)"
                                          (click)="this.handleOnClick($event)"
                                          (dblclick)="this.handleOpenGridCellEditor($event)"
                                          class="margin-left-10px">
                            {{strRadioButton}}
                        </mat-radio-button>
                        }
                    </mat-radio-group>
                </div>
                }
                @if (UseHorizontalTabFormat) {
                <div>
                    <mat-tab-group (selectedTabChange)="radioTabClick($event);" [selectedIndex]="selectedTabIndex()">
                        @for (strRadioButton of this.SelectOptions; track strRadioButton) {
                        <mat-tab (click)="radioTabClick($event)" label="{{strRadioButton}}"></mat-tab>
                        }
                    </mat-tab-group>
                </div>
                }
                @if (UseToggleSwitchFormat) {
                <div>
                    @if(FormField.displayName != null && FormField.displayName.trim() != ''){
                    <div class="field-label">
                        @if (!FieldIsInGrid) {
                        {{DisplayName}}
                        }
                        @if (this.FormField.required) {
                        <span style="color: #EF0000;">*</span>
                        }
                    </div>
                    }
                    <mat-button-toggle-group formControlName="radio_buttons_form" class="small-toggle-button">
                        @for (strRadioButton of this.SelectOptions; track strRadioButton) {
                        <mat-button-toggle class="" (change)="toggleSwitchClick($event)" value="{{strRadioButton}}">{{strRadioButton}}</mat-button-toggle>
                        }
                    </mat-button-toggle-group>
                </div>
                }
            </form>
            }
            @if ((! this.SelectOptions) || (this.SelectOptions.length === 0)) {
            <div>{{DisplayName}}</div><br />
            <span>This control has no radio buttons defined</span>
            }
        </div>
        <div style="margin-top:-10px">
            <ng-container *ngTemplateOutlet="tooltipTemplate"></ng-container>
        </div>
    </div>
    }
</div>

